export default "__VITE_ASSET__B1i204_N__"